import { render } from "./MalaUsers.vue?vue&type=template&id=08490890&scoped=true"
import script from "./MalaUsers.vue?vue&type=script&lang=js"
export * from "./MalaUsers.vue?vue&type=script&lang=js"

import "./MalaUsers.vue?vue&type=style&index=0&id=08490890&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08490890"]])

export default __exports__